import { ExportTypes, IExportType } from './Types';
import { action } from 'typesafe-actions';

export const getExport = (payload: { filters: any, exportType: IExportType, page: string }) => action(ExportTypes.GET_EXPORT, payload);

export const getExportDashboardPdf = (filters: any) => action(ExportTypes.GET_EXPORT_DASHBOARD_PDF, filters);
export const getExportDashboardXls = (filters: any) => action(ExportTypes.GET_EXPORT_DASHBOARD_XLS, filters);
export const getExportPlayerPdf = (filters: any) => action(ExportTypes.GET_EXPORT_PLAYER_PDF, filters);
export const getExportPlayerXls = (filters: any) => action(ExportTypes.GET_EXPORT_PLAYER_XLS, filters);
export const getExportStatsEvolutionPdf = (filters: any) => action(ExportTypes.GET_EXPORT_STATS_EVOLUTION_PDF, filters);
export const getExportStatsEvolutionXls = (filters: any) => action(ExportTypes.GET_EXPORT_STATS_EVOLUTION_XLS, filters);
export const getExportDashboardDetailsPdf = (filters: any) => action(ExportTypes.GET_EXPORT_DASHBOARD_DETAILS_PDF, filters);
export const getExportDashboardDetailsXls = (filters: any) => action(ExportTypes.GET_EXPORT_DASHBOARD_DETAILS_XLS, filters);
export const getExportSuccess = (res:any) => action(ExportTypes.GET_EXPORT_SUCCESS, res);
export const getExportError = () => action(ExportTypes.GET_EXPORT_ERROR, []);
export const cleanFile = () => action(ExportTypes.CLEAN_FILE,[]);
export const setExportFile = (file:any) => action(ExportTypes.SET_EXPORT_FILE, file)
